//LIBRARIES
import { CSSTransitionGroup } from 'react-transition-group';
import { updateLanguage } from 'react-localize-redux';
import { browserHistory } from 'react-router';
import React, { Component } from 'react';
import { SyncLoader } from 'halogenium';
import styled from 'styled-components';
import { connect } from 'react-redux';
import capitalize from 'capitalize';

//HELPERS
import { getTranslatedString, getLandlordVerbiageOrTranslatedString } from 'helpers/i18n';
import LandlordLogo from "components/shared/LandlordLogo";
import { getCurrentLocale } from 'helpers/i18n';
import { deepDiver } from 'helpers/utilities';
import { AccentColor } from 'helpers/AccentColorHelper';

//COMPONENTS
import TenantMaintenanceSurveyForm from './components/TenantMaintenanceSurveyForm';
import LanguageOptionsCentered from 'components/shared/LanguageOptionsCentered';
import CtaPrimary from 'components/ui/CtaPrimary';

//ACTIONS
import * as surveyActions from 'actions/surveyActions';


const StyledLanguageOptionsCenteredContainer = styled.div`
  margin-top: 24px;
`;

const StyledGreeting = styled.p`
  font-family: 'Circular';
  font-size: 18px;
`;

const StyledThankYou = styled.p`
  font-family: 'Circular';
  font-size: 21px;
  margin-top: 24px;
  text-align: center;
`;

const StyledLeaveSurvey = styled.p`
  font-family: 'Circular';
  font-size: 15px;
  margin-top: 16px;
  margin-bottom: 16px;
  text-align: center;
`;

const StyledContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
`;

export default connect(
  store => {
    return {
      maintenanceSurveyVerification: store.survey.maintenance_survey_verification,
      showSuccessfulVerificationMessage: store.survey.showSuccessfulVerificationMessage,
      showLoader: store.survey.showLoader,
    };
  },
  dispatch => {
    return {
      getMaintenanceSurveyVerification: uuid => {
        dispatch(surveyActions.maintenanceSurveyVerification(uuid));
      },
      submitMaintenanceSurvey: (uuid, values) => {
        dispatch(surveyActions.submitMaintenanceSurvey(uuid, values));
      },
      displayLoader: shouldDisplay => {
        dispatch(surveyActions.displayLoader(shouldDisplay));
      },
      updateLanguage: locale => {
        dispatch(updateLanguage(locale));
      },
    };
  }
)(
  class TenantMaintenanceVerification extends Component {
    componentDidMount() {
      this.setState({ shouldShowGoogleReview: false })

      const query_params = browserHistory.getCurrentLocation().query;
      if (query_params && query_params.uuid) {
        this.props.displayLoader(true);
        this.props.getMaintenanceSurveyVerification(query_params.uuid);
      } else {
        browserHistory.push('/dashboard');
      }
    }

    handleSubmit = values => {
      const uuid = this.props.maintenanceSurveyVerification.verification_token;
      this.props.submitMaintenanceSurvey(uuid, values);
      this.shouldShowGoogleSurvey(values);
    };

    shouldShowGoogleSurvey = values => {
      const ratingIsAboveMinimum = parseInt(values.recommendation) >= this.props.maintenanceSurveyVerification.google_reviews_minimum_rating;
      if (ratingIsAboveMinimum && values.happy) {
        this.setState({shouldShowGoogleReview: true})
      }
    };

    submitGoogleReview = () => {
      const googleReviewLink = this.props.maintenanceSurveyVerification.google_review_link
      window.open(googleReviewLink, '_blank').focus();
      this.handleSubmit({ review_submitted: true });
    };

    render() {
      let tenant_name = null;
      let landlord_name = null;
      let duration = null;
      let verbiages = null;
      let showContactField = true;

      if (this.props.maintenanceSurveyVerification) {
        const greetingNameType = this.props.maintenanceSurveyVerification.greeting_name_type;
        tenant_name = capitalize(this.props.maintenanceSurveyVerification.lead[greetingNameType]);
        landlord_name = capitalize(this.props.maintenanceSurveyVerification.landlord_name);
        verbiages = this.props.maintenanceSurveyVerification.verbiages;
        showContactField = this.props.maintenanceSurveyVerification.show_contact;
      }
      
      return (
        <StyledContainer>
          {this.props.showLoader && (
            <div style={{ marginTop: '25px' }}>
              <SyncLoader color="#ff5656" size="12px" />
            </div>
          )}

          {this.renderThankYou(this.state, this.submitGoogleReview, verbiages)}

          {(this.props.maintenanceSurveyVerification && !this.props.showSuccessfulVerificationMessage) && (
            <CSSTransitionGroup transitionName="fade_in" transitionAppear={true} style={{   maxWidth: '800px' }}>
              <LandlordLogo
                maxWidth="273px"
                height="100px"
                textHeight="40px"
                textAlign="left"
              />
              <div>
                <h3
                  style={{
                    textAlign: 'left',
                    fontSize: '30px',
                    marginBottom: '20px',
                  }}
                >
                  {' '}
                  {getTranslatedString('maintenanceSurvey.survey')}{' '}
                </h3>
                <div className="row" style={{ textAlign: 'left' }}>
                  <div>
                    <StyledGreeting>
                      {getLandlordVerbiageOrTranslatedString(
                        'nameGreeting',
                        {
                          name: tenant_name,
                        },
                        verbiages
                      )}
                    </StyledGreeting>
                    <StyledGreeting>
                      {getTranslatedString('maintenanceSurvey.yourFeedback')}
                    </StyledGreeting>
                  </div>
                  <TenantMaintenanceSurveyForm
                    onSubmit={this.handleSubmit}
                    landlord_name={landlord_name}
                    tenant_name={tenant_name}
                    duration={duration}
                    showContactField={showContactField}
                  />
                </div>
              </div>
            </CSSTransitionGroup>
          )}
          <StyledLanguageOptionsCenteredContainer>
            <LanguageOptionsCentered onLanguageChange={() => window.location.reload()} />
          </StyledLanguageOptionsCenteredContainer>
        </StyledContainer>
      );
    }


    renderThankYou = (state, submitGoogleReview, verbiages) => {
      if (!this.props.showSuccessfulVerificationMessage) return null;

      return (
        <CSSTransitionGroup transitionName="fade_in" transitionAppear={true}>
          <LandlordLogo
            maxWidth="273px"
            height="100px"
            textHeight="40px"
            textAlign="center"
          />
          <StyledThankYou>
            {getTranslatedString('maintenanceSurvey.surveyComplete')}
          </StyledThankYou>
          {this.renderGoogleSurvey(state, submitGoogleReview, verbiages)}
        </CSSTransitionGroup>
      );
    }

    renderGoogleSurvey = (state, submitGoogleReview, verbiages) => {
      if (!this.props.maintenanceSurveyVerification) return null;
      if (!this.props.maintenanceSurveyVerification.google_reviews_active) return null;
      const googleReviewLink = this.props.maintenanceSurveyVerification.google_review_link
      if (!googleReviewLink) return null;
      if(!state.shouldShowGoogleReview) return null;

      let shareReviewVerbiage = deepDiver(
        verbiages,
        `residentMaintenanceSurveyGoogleReview.${getCurrentLocale()}`
      );

      if (!shareReviewVerbiage) {
        shareReviewVerbiage = getTranslatedString('maintenanceSurvey.leaveUsAReview');
      }

      return (
        <React.Fragment>
          <StyledLeaveSurvey>
            {shareReviewVerbiage}

          </StyledLeaveSurvey>
          <CtaPrimary
            onClick={() => submitGoogleReview()}
            accentColor={AccentColor()}
          >
            {getTranslatedString('maintenanceSurvey.shareReview')}
          </CtaPrimary>
        </React.Fragment>
      );
    }
  }
);
